import { render, staticRenderFns } from "./noHandle.vue?vue&type=template&id=f487aef4&scoped=true"
import script from "./noHandle.vue?vue&type=script&lang=js"
export * from "./noHandle.vue?vue&type=script&lang=js"
import style0 from "./noHandle.vue?vue&type=style&index=0&id=f487aef4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f487aef4",
  null
  
)

export default component.exports